export default __webpack_public_path__ + "static/media/MinionProRegular.c87c1916.ttf";